/**
 * If updating/refactoring anything related to translations funcionality, 
 * please also update the docs at: https://alephrnd.atlassian.net/wiki/spaces/TECHD/pages/335020166/Internationalization
 */
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import resources from 'resources/translations.json';

i18n.use(initReactI18next).init({
	resources,
	nsSeparator:   false,
	keySeparator:  false,
	interpolation: {prefix: '%', suffix: '%'},
});

export default i18n;
